export const paymentLinkQrModalTheme = {
  container: {
    bg: 'palette.primary.40',
    borderRadius: '12px',
  },
  qr: {
    bg: 'palette.white',
    borderRadius: '12px',
  },
};
